var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconOval = function SvgIconOval(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 19,
    x: 0.5,
    y: 0.5,
    fill: "#F9F9F8",
    fillRule: "evenodd",
    stroke: "#7D7971",
    rx: 9.5
  })));
};
export { SvgIconOval as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB2aWV3Qm94PSIwIDAgMzAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZyBpZD0iaWNvbi9vdmFsIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cmVjdCBzdHJva2U9IiM3RDc5NzEiIGZpbGw9IiNGOUY5RjgiIHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMjkiIGhlaWdodD0iMTkiIHJ4PSI5LjUiPjwvcmVjdD4KICAgIDwvZz4KPC9zdmc+";